import { createContext, useEffect, useState } from 'react';

export const MazeResultContext = createContext({});

const MazeResultProvider = ({ children }) => {
    const [mazeOneResult, setMazeOneResult] = useState('');
    const [mazeTwoResult, setMazeTwoResult] = useState('');
    const [mazeThreeResult, setMazeThreeResult] = useState('');
    const [finalResult, setFinalResult] = useState({});
    useEffect(() => {
        setFinalResult({
            mazeOneResult,
            mazeTwoResult,
            mazeThreeResult,
        });
        
    }, [mazeOneResult, mazeTwoResult, mazeThreeResult]);

    return (
        <MazeResultContext.Provider value={{ mazeOneResult, setMazeOneResult, mazeTwoResult, setMazeTwoResult, mazeThreeResult, setMazeThreeResult, finalResult, setFinalResult }}>
            {children}
        </MazeResultContext.Provider>
    );
};

export default MazeResultProvider;